/**************************************************
 * Nombre:       Casilla_Avatar_Titulo_Dato
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {TableCell} from "@mui/material";
import {useEffect} from "react";

const Casilla_Img_Primera_Arr = ({datos, dir, index}) => {


    useEffect(() => {
        console.log(datos)
    }, [datos]);
    return (
        <TableCell key={`${index}6w`} variant={'body'} align={dir}>
            <img src={datos[0]} width={'100%'} height={'auto'} style={{borderRadius: 4, width: 100}}/>
        </TableCell>
    )

}
export default Casilla_Img_Primera_Arr